import { clusterBy, getCurrentStateOfLvDocument } from '../Utils/helpers';
import { getToken } from '../Utils/Common';
import React from 'react';
import uuid from 'react-uuid';
import { getAllAnnotationsDB } from '../Database/AnnotationsDAO';
import { Accordion, Button, Card, Col, Row, Table } from 'react-bootstrap';
import { NODATACATEGORY } from '../AppTextConstants';
import parse from 'html-react-parser';
import '../Styles/Reports/displayReportData.css';

//f771996c-b569-41bd-b1fa-14d1363ef86f

//import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
//import {faSearch} from '@fortawesome/free-solid-svg-icons';
import ReportAnnotatorModalComponent from '../Components/Report/ReportAnnotatorModalComponent';

//let apilink = "https://d25c1smh4gyzd4.cloudfront.net"
let apilink = process.env.REACT_APP_BACKEND_API_URI;

/**
 * Function provides the summary with an empfehlung and total value for a given AGL.
 * @param o
 * @param clusterByAGL
 * @param typeR
 * @returns {string}
 */
export function getSummaryAnnotions(clusterByAGL, typeR, o) {
    let uuidKey = uuid();
    let empfehlung = '';

    let totalValue = 0;
    clusterByAGL[0][o].map((a) => (totalValue = totalValue + a.price));
    totalValue = Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
    }).format(parseFloat(totalValue).toFixed(2));
    clusterByAGL[0][o].map(
        (t) =>
            (empfehlung = (
                <p
                    style={{
                        textAlign: 'justify'
                    }}
                    key={uuidKey}
                >
                    {parse(t.recomm)}
                    {t.formel !== '' && t.formel !== 'none' ? <br /> : ''}
                    {t.formel !== '' && t.formel !== 'none' ? <br /> : ''}
                    {t.formel !== '' && t.formel !== 'none' ? parse(t.formel) : ''}
                </p>
            ))
    );

    return empfehlung;
}

/**
 * Function provides the Annotations and related data for an AGL.
 * @param params
 * @returns {*}
 */
export function getAnnotationsData(params) {
    let key = params.key;
    let clusterByAGL = params.clusterByAGL;
    let o = params.o;
    let focusAGLs = params.focusAGLs;
    let focusUIDs = params.focusUIDs;
    let setAGLs = params.setAGLs;
    let removeAGLs = params.removeAGLs;
    //console.log(focusAGLs, focusUIDs, setAGLs, removeAGLs, key);
    let uuidKey = uuid();
    let emptyReplacer = 'Kein Kurztext vorhanden';

    function shortTextView(shortText) {
        if (shortText === undefined) {
            return <td>-</td>;
        } else if (shortText !== '') {
            return <td>{shortText}</td>;
        } else return <td>{emptyReplacer}</td>;
    }

    function testmodal(data) {
        //console.log(params.modalData.lvInfo.lvInfo.data.OZ);
        let positiondata = params.modalData.lvInfo.lvInfo.data.OZ.filter((e) => e.row_id === data.rowId)[0];
        return (
            <td>
                <ReportAnnotatorModalComponent
                    data={data}
                    modalData={'\n' + positiondata.hinweis + positiondata.long_text}
                />
            </td>
        );
    }
    //whiteSpace: "nowrap"

    // Removes 'unique_id' key value for ease of duplicate check
    let newClusterByAGL = clusterByAGL[0][o].map((data) => {
        //delete data['unique_id'];
        return data;
    });

    // Prepares unique entries for Web Report
    let reportDataSet = new Set();
    let uniqueReportTableData = [];
    for (let newClusterByAGLEntry of newClusterByAGL) {
        let concatenatedValue = Object.values(newClusterByAGLEntry).join('');
        if (!reportDataSet.has(concatenatedValue)) {
            reportDataSet.add(concatenatedValue);
            uniqueReportTableData.push(newClusterByAGLEntry);
        }
    }

    return uniqueReportTableData.map((data) => (
        <>
            <tr key={uuidKey}>
                <td>
                    <input
                        key={uuidKey}
                        type="checkbox"
                        className="handwaiCheckbox nestingCheckbox"
                        onChange={(e) =>
                            selectSpecific({
                                event: e,
                                key: key,
                                o: o,
                                individualContent: data,
                                focusAGLs: focusAGLs,
                                focusUIDs: focusUIDs,
                                setAGLs: setAGLs,
                                removeAGLs: removeAGLs
                            })
                        }
                    />
                </td>
                <td>{data.ordnungsziffer}</td>
                {shortTextView(data.shortText)}

                {testmodal(data)}
                {/*<td>
                <Button className={"handwai-btn-report"}
                disabled={data.shortText==="nan"}
            onClick={()=>
            {
                let baseURL = "https://www.google.com/search?q="
                window.open(baseURL + data.googleText, 'googletext')}
            }
            ><FontAwesomeIcon icon={faSearch}/> Suchen</Button>
                {ReportAnnotatorModalComponent}
                <Button className={"handwai-btn-report"}
            onClick={()=>
            {
                testmodal()
            }
            }
            ><FontAwesomeIcon icon={faSearch}/> Suchen</Button>

            </td>*/}

                <td>{data.reason}</td>
                {/* <td className="menge">{data.menge}</td> */}
                <td className="menge">{isNaN(data.menge) ? 0 : data.menge}</td>
                <td>{data.unit}</td>
            </tr>
        </>
    ));
}

/**
 * Function provides the total number of annotations for an AGL.
 * @param clusterByAGL
 * @param o
 * @returns {number}
 */
export function getNumberOfAnnotations(clusterByAGL, o) {
    let counter = 0;
    clusterByAGL[0][o].map(() => (counter = counter + 1));
    return counter;
}

function getIntersection(array1, array2) {
    return array1.filter(value => array2.includes(value));
}

let getPositionCategoryDataForAGL = (adviceID, adviceCatalog, positionCategoryInfo) => {
    let thePositionCategoryData = [];
    let tableData;
    let foundData = false;
    //let positionCategories;

    for (let key in positionCategoryInfo) {
        let advice = adviceCatalog.find(advice => advice.uidid === adviceID);
        //positionCategories = advice.pcategories;
        let categories = key.split(",").map(cat => cat.trim());
        if (getIntersection(categories, advice.pcategories).length === categories.length) {
            thePositionCategoryData.push(...positionCategoryInfo[key].filter(pos => pos.type === "Item"));
            foundData = true;
         }
    }

    if (!foundData) {
        return '';
    }

    tableData = thePositionCategoryData.map((item, index) => (
        <Table key={index} striped bordered hover variant="dark">
            <thead>
            <tr>
                <th>OZ</th>
                <th>Kurztext</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>{item.ref}</td>
                <td>{item.hinweis}</td>
            </tr>
            <tr>
                <td colSpan="2" style={{ 'white-space': 'pre-wrap' }}> {item.long_text}</td>
            </tr>
            </tbody>
        </Table>
    ));

    let positionHeader = (
        <>
            <br />
            <label className="handwai-text-label-normal" style={{ fontWeight: 'bold' }}>
                {"Position(en) im LV:"}
            </label>
            ;
        </>
    );

    return (
        <>
            <Row>
                <Col md={1} />
                <Col className={'addMarginLeftMinus50'}>
                    {positionHeader} {tableData}
                </Col>
            </Row>
        </>
    );
};

/**
 * Function provides the data to UI for given Annotations (content) and category (typeR).
 * @param param
 * @returns Accordion-body-data
 */
export async function getReportContent(param) {
    let content = param.content;
    let typeR = param.dType;
    let setAGLs = param.setAGLs;
    let removeAGLs = param.removeAGLs;
    let hinweisAGLs = param.hinweisAGLs;
    let potenzialAGLs = param.potenzialAGLs;
    let risikoAGLs = param.risikoAGLs;
    let hinweisUIDs = param.hinweisUIDs;
    let potenzialUIDs = param.potenzialUIDs;
    let risikoUIDs = param.risikoUIDs;
    let positionCategoryInfo = param.positionCategoryData;
    let adviceCatalog = param.adviceCatalog;

    if (content !== null && content !== '[]') {
        //Group by AGL
        let clusterByAGL = clusterBy(content, 'anspruchsgrundlage');
        clusterByAGL = [clusterByAGL];

        let advices_obj = Object.keys(clusterByAGL[0]).map(key => ({
            anspruch: key,
            adviceID: clusterByAGL[0][key][0].adviceID
        }));

        let uuidKeys = uuid();

        let focusAGLs = [];
        let focusUIDs = [];

        if (typeR === 'Hinweis') {
            focusAGLs = hinweisAGLs;
            focusUIDs = hinweisUIDs;
        } else if (typeR === 'Potenzial') {
            focusAGLs = potenzialAGLs;
            focusUIDs = potenzialUIDs;
        } else if (typeR === 'Risiko') {
            focusAGLs = risikoAGLs;
            focusUIDs = risikoUIDs;
        }

        advices_obj = advices_obj.sort((a, b) => a['anspruch'].localeCompare(b['anspruch']));

        return advices_obj.map((advice_obj, index) => (
            <>
                <Card className="handwai-dark" key={uuidKeys}>
                    <Card.Header>
                        <Row>
                            <Col md={1}>
                                {focusAGLs.includes(advice_obj.anspruch)
                                    ? includedInput(uuidKeys, focusAGLs, advice_obj.anspruch, setAGLs, removeAGLs)
                                    : excludedInput(uuidKeys, focusAGLs, advice_obj.anspruch, setAGLs, removeAGLs)}
                            </Col>
                            <Col md={10} className="addMarginLeftMinus50">
                                <Accordion.Toggle
                                    as={Button}
                                    className="handwai-btn-create add1110Width"
                                    style={{ textAlign: 'left' }}
                                    eventKey={index + 1}
                                >
                                    {parse(advice_obj.anspruch)} [Anzahl: {getNumberOfAnnotations(clusterByAGL, advice_obj.anspruch)}]{' '}
                                </Accordion.Toggle>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Accordion.Collapse eventKey={index + 1}>
                        <Card.Body>
                            <div
                                style={{
                                    display: 'flex',
                                    flex: 1,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    padding: '20px',
                                    color: '#fff',
                                    flexDirection: 'column'
                                }}
                            >
                                <h3>Info</h3>
                                <hr
                                    style={{
                                        border: '1px solid #fff',
                                        width: '100%'
                                    }}
                                />
                                <div
                                    style={{
                                        padding: '20px'
                                    }}
                                >
                                    {getSummaryAnnotions(clusterByAGL, typeR, advice_obj.anspruch)}
                                </div>
                            </div>

                            <br />

                            <Row>
                                <Col md={1} />
                                <Col className={'addMarginLeftMinus50'}>
                                    <table
                                        className="table webReportTableSecond"
                                        style={{
                                            width: '100%'
                                        }}
                                    >
                                        <thead
                                            style={{
                                                width: '100%'
                                            }}
                                        >
                                            <tr>
                                                <th className="no-sort">Wählen</th>
                                                <th className="sort">OZ</th>
                                                <th>Kurztext</th>
                                                <th>Aktion</th>
                                                <th>Ursache</th>
                                                <th className="sort">Menge</th>
                                                <th className="sort">Einheit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {getAnnotationsData({
                                                modalData: param.modalData,
                                                key: uuidKeys,
                                                clusterByAGL: clusterByAGL,
                                                o: advice_obj.anspruch,
                                                focusAGLs: focusAGLs,
                                                focusUIDs: focusUIDs,
                                                setAGLs: setAGLs,
                                                removeAGLs: removeAGLs
                                            })}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>

                            <br />
                            {
                                (positionCategoryInfo !== null) ?
                                getPositionCategoryDataForAGL(advice_obj.adviceID, adviceCatalog, positionCategoryInfo) : ''
                            }
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </>
        ));
    } else {
        return <p className="handwai-text-label-normal">{NODATACATEGORY}</p>;
    }
}

export function addSelectedAGLs(o, setAGLs) {
    setAGLs(o);
}

function removeSelectedAGLs(o, removeAGLs) {
    removeAGLs(o);
}

export function includedInput(uuid, focusAGLs, o, setAGLs, removeAGLs) {
    return (
        <input
            type="checkbox"
            key={uuid}
            id={uuid}
            className="handwaiCheckbox"
            checked="true"
            onInput={(event) => {
                if (!focusAGLs.includes(o)) {
                    addSelectedAGLs(o, setAGLs);
                    event.target.checked = true;
                } else {
                    removeSelectedAGLs(o, removeAGLs);
                    event.target.checked = false;
                    event.target.removeAttribute('checked');
                }
            }}
        />
    );
}

export function excludedInput(uuid, focusAGLs, o, setAGLs, removeAGLs) {
    return (
        <input
            type="checkbox"
            key={uuid}
            id={uuid}
            className="handwaiCheckbox"
            onInput={(event) => {
                if (!focusAGLs.includes(o)) {
                    addSelectedAGLs(o, setAGLs);
                    event.target.checked = true;
                } else {
                    removeSelectedAGLs(o, removeAGLs);
                    event.target.checked = false;
                }
            }}
        />
    );
}

function isChecked() {
    let inputElements = [].slice.call(document.querySelectorAll('.nestingCheckbox'));
    return inputElements.filter((chk) => chk.checked).length;
}

/**
 * Select specific content from an AGL
 * @param params
 */
export function selectSpecific(params) {
    let e = params.event;
    let key = params.key;
    let o = params.o;
    let data = params.individualContent;
    let focusAGLs = params.focusAGLs;
    let focusUIDs = params.focusUIDs;
    let setAGLs = params.setAGLs;
    let removeAGLs = params.removeAGLs;

    if (e.target.checked === true && !focusUIDs.includes(data)) {
        // first uncheck the AGL checkbox
        document.getElementById(key).checked = false;
        addSelectedAGLs(data, setAGLs);
        // check if there is any nesting checkbox selected
        if (isChecked() >= 1) {
            if (!focusAGLs.includes(o)) {
                addSelectedAGLs(o, setAGLs);
            }
            // otherwise remove the principal AGL.
        } else {
            removeSelectedAGLs(o, removeAGLs);
        }
    } else {
        removeSelectedAGLs(data, removeAGLs);
    }
}

export function getSortedAnnotations() {
    return getAllAnnotationsDB().then(function (result) {
        // a stable sorting algorithm
        return result.sort(
            (firstItem, secondItem) => firstItem.annotation_data.rowId - secondItem.annotation_data.rowId
        );
    });
}

export function save_before_publish(extractedAnnotationsData) {
    //Send clustered advice ID, with LV ID
    let lv_id = localStorage.getItem('parsedlv_id');
    // Get the current state of lv document to save the
    let positionTexts = getCurrentStateOfLvDocument();
    const analyse = {
        lv_id: lv_id,
        is_checkpoint: false,
        list_json: extractedAnnotationsData,
        lvDocument: positionTexts
    };
    // APi call for save annotations for the annotator microservice
    fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/v2/resources/annotations`, {
        method: 'POST',
        headers: { 'Content-type': 'application/json; charset=UTF-8', Authorization: 'Bearer ' + getToken() },
        body: JSON.stringify(analyse)
    });
}

async function remove(arr, val, rowID) {
    let res = [];
    for (let item of arr) {
        if (rowID.includes(item.row_id)) {
            if (item.norm.toLowerCase() !== val) {
                res.push(item);
            }
        } else {
            res.push(item);
        }
    }
    return res;
}

/**
 * This function publishes the lv but also has business logic for ai annotations
 */
const labelParams = [
    '<p>Planungsfabrikat</p>',
    'Planungsfabrikat',
    '<p>Nicht Neutral</p>',
    'Nicht Neutral',
    '<p>Unklar</p>',
    'Unklar',
    'stundenlohnarbeiten',
    '<p>stundenlohnarbeiten</p>',
    'Stundenlohnarbeiten',
    '<p>Stundenlohnarbeiten</p>',
    'beschilderung',
    '<p>beschilderung</p>',
    'Beschilderung',
    '<p>Beschilderung</p>'
];
const stundenParam = [
    'ersthelfers',
    'Ersthelfers',
    'fachingenieurs',
    'Fachingenieurs',
    'FachIngenieurs',
    'Fachingenieur',
    'FachIngenieur',
    'fachingenieur',
    'Fachingenieure',
    'FachIngenieure',
    'fachingenieure',
    'Monteure',
    'Techniker',
    'techniker',
    'Montagemeister',
    'montagemeister',
    'meister',
    'Meister',
    'Ersthelfer',
    'ersthelfer',
    'Monteure',
    'monteure',
    'Systemtechniker',
    'systemtechniker',
    'Auszubildender',
    'elektro-ingenieur',
    'Elektro-Ingenieur',
    'elektro-ingenieure',
    'Elektro-Ingenieure',
    'elektro-ingenieurs',
    'Elektro-Ingenieurs',
    'auszubildender',
    'Fachingenieure',
    'fachingenieurs',
    'Fachingenieurs',
    'fachingenieure',
    'Monteure',
    'monteur',
    'monteurs',
    'Monteurs',
    'a-monteur',
    'A-monteur',
    'b-monteur',
    'B-Monteur',
    'c-monteur',
    'C-Monteur',
    'monteur/-in',
    'Monteur/-in',
    'obermonteur',
    +'Obermonteur',
    'Obermonteur/-in',
    'obermonteur/-in',
    'obermonteur',
    'Helfer/-in',
    'helfer/-in',
    'helfers',
    'Helfers',
    'Helfer',
    'helfer',
    'o-monteur',
    'O-monteur',
    'O-Monteur',
    'elekro-monteur',
    'Elekro-Monteur',
    'Elekro-monteur',
    'kernbohrmonteur',
    'Kernbohrmonteur',
    'KernbohrMonteur',
    'lehrling',
    'Lehrling',
    'Ausbildender',
    'ausbildender',
    'azubi',
    'Azubi',
    'ingenieur',
    'Ingenieur',
    'MSR-Ingenieur',
    'msr-ingenieur',
    'Bauhelfer',
    'bauhelfer',
    'bauhelfer/-in',
    'Bauhelfer/-in',
    'sanitärhelfer',
    'Sanitärhelfer',
    'sanitärhelfer/-in',
    'Sanitärhelfer/-in',
    'bauwerker',
    'Bauwerker',
    'facharbeiter',
    'Facharbeiter',
    'facharbeiter/-in',
    'Facharbeiter/-in',
    'geselle',
    'Geselle',
    'meister/-in',
    'Meister/-in',
    'Monteur',
    'techniker/-in',
    'Techniker/-in',
    'techniker',
    'kundendiensttechniker',
    'Kundendiensttechniker',
    'Elektrikers',
    'elektrikers',
    'elekriker',
    'elekriker',
    'elekriker/-in',
    'Elekriker/-in',
    'Systemintegrator/-in',
    'systemintegrator/-in',
    'Systemintegrator',
    'systemintegrator',
    'GA-Techniker',
    'ga-techniker',
    'objektleiter/-in',
    'objektleiter',
    'Objektleiter',
    'Objektleiter/-in'
];

export async function publish(extractedAnnotationsData) {
    //Send clustered advice ID, with LV ID
    let lv_id = localStorage.getItem('parsedlv_id');
    let clustered = clusterBy(extractedAnnotationsData, 'ord');
    let result = [];
    let ord = [];
    let tailored = [];
    for (let value of Object.values(clustered)) {
        let unique = [];
        value.map((x) =>
            unique.filter((a) => a.Annotation === x.Annotation && labelParams.includes(x.norm)).length > 0
                ? null
                : unique.push(x)
        );
        let copyUnique = [...unique];
        copyUnique.forEach(function (item) {
            if (stundenParam.includes(item.Annotation.toLowerCase())) {
                tailored.push(item);
                ord.push(item.row_id);
            }
        });
        result.push(...unique);
    }

    let final = await remove(result, 'stundenlohnarbeiten', [...new Set(ord)]);
    final.push(...tailored);
    let clusterByAdviceID = clusterBy(final, 'adviceID');

    const annotationsData = {
        lv_id: lv_id,
        is_checkpoint: false,
        list_json: final, //this is for AI data management
        cluster_adviceID: clusterByAdviceID // This is for all types of reports
    };

    // APi call for save annotations for the report microservice
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/report/v1/resources/report`, {
        method: 'POST',
        headers: { 'Content-type': 'application/json; charset=UTF-8', Authorization: 'Bearer ' + getToken() },
        body: JSON.stringify(annotationsData)
    });
}

export async function publish_report(data) {
    data.token = getToken();
    return fetch(apilink + `annotator/publish`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function getStatistics(lvID) {
    return fetch(apilink + `annotator/get_report_stats/` + lvID, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then((response) => response.clone().json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log('Error:', error);
        });
}

// export async function getReportDetail(lvID, detailType){
//     return fetch(apilink + `/annotator/get_report/`+lvID+"/"+detailType, {
// 		method: 'GET',
// 		headers: {
//             "Content-Type": "application/json"
//         }
// 	}).then((response) => response.clone().json())
// 		.then((data) => {
// 			return data;
// 		})
// 		.catch((error) => {
// 			console.log('Error:', error);
// 		});
// }

export async function getReportDetail(lvID) {
    return fetch(apilink + `annotator/get_report/` + lvID, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: getToken(), met: 'GET' })
    })
        .then((response) => response.clone().json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log('Error:', error);
        });
}

export async function getAdditionalReportDetail(lvID) {
    return fetch(apilink + `annotator/get_add_report`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: getToken(), lv_id: lvID })
    })
        .then((response) => response.clone().json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log('Error:', error);
        });
}

// export async function getReportLink(lvID){
//     return fetch(apilink + `/annotator/get_link/`+lvID, {
// 		method: 'GET',
// 		headers: {
// 			"token":getToken(),
//             "Content-Type": "application/json"
//         }
// 	}).then((response) => response.clone().json())
// 		.then((data) => {
// 			return data;
// 		})
// 		.catch((error) => {
// 			console.log('Error:', error);
// 		});
// }

export async function getReportLink(lvID) {
    return fetch(apilink + `annotator/get_link/` + lvID, {
        method: 'POST',
        headers: {
            token: getToken(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: getToken(), met: 'GET' })
    })
        .then((response) => response.clone().json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log('Error:', error);
        });
}

export function getRepLinkApi(report_id) {
    let tmp = `${process.env.REACT_APP_BASE_URI}` + report_id;
    return fetch(tmp, {
        method: 'GET',
        headers: { Authorization: 'Bearer ' + getToken() }
    })
        .then((response) => response.clone().json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log('Error:', error);
        });
}

export async function sendClusteredAdviceID(annotationsAll) {
    let lv_id = localStorage.getItem('parsedlv_id');
    let arrayAnnot2 = [];
    for (let annotData of annotationsAll) {
        arrayAnnot2.push(annotData.annotation_data);
    }

    let clusterByAdviceID = clusterBy(arrayAnnot2, 'adviceID');

    // Prepare data for API Call
    let clusterAdviceID = {
        lv_id: lv_id,
        cluster_adviceID: clusterByAdviceID
    };

    // API Call to send clustered Advice ID
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/report/v1/resources/clusteradvices`, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            Authorization: 'Bearer ' + getToken()
        },
        body: JSON.stringify(clusterAdviceID)
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function getWebReportData(lv_id) {
    // API Call
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/report/v1/resources/reportdata`, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            Authorization: 'Bearer ' + getToken()
        },
        body: JSON.stringify({ lv_id: lv_id })
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}















/*
import {clusterBy, getCurrentStateOfLvDocument} from '../Utils/helpers';
import {getToken} from '../Utils/Common';
import React from 'react';
import uuid from 'react-uuid';
import {getAllAnnotationsDB} from '../Database/AnnotationsDAO';
import {Accordion, Button, Card, Col, Row, Table} from 'react-bootstrap';
import {NODATACATEGORY} from '../AppTextConstants';
import parse from 'html-react-parser';
import '../Styles/Reports/displayReportData.css';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from '@fortawesome/free-solid-svg-icons';

//import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
//import {faSearch} from '@fortawesome/free-solid-svg-icons';

//let apilink = "https://d25c1smh4gyzd4.cloudfront.net"
let apilink = process.env.REACT_APP_BACKEND_API_URI

/!**
 * Function provides the summary with an empfehlung and total value for a given AGL.
 * @param o
 * @param clusterByAGL
 * @param typeR
 * @returns {string}
 *!/
export function getSummaryAnnotions(clusterByAGL, typeR, o) {
    let uuidKey = uuid();
    let empfehlung = '';

    let totalValue = 0;
    clusterByAGL[0][o].map((a) => (totalValue = totalValue + a.price));
    totalValue = Intl.NumberFormat('de-DE', {
        style: 'currency', currency: 'EUR'
    }).format(parseFloat(totalValue).toFixed(2));
    clusterByAGL[0][o].map((t) => (empfehlung = (<tr key={uuidKey}>
        <td>
            {parse(t.recomm)}
            {t.formel !== '' && t.formel !== 'none' ? <br/> : ''}
            {t.formel !== '' && t.formel !== 'none' ? <br/> : ''}
            {t.formel !== '' && t.formel !== 'none' ? parse(t.formel) : ''}
        </td>
    </tr>)));

    return empfehlung;
}

/!**
 * Function provides the Annotations and related data for an AGL.
 * @param params
 * @returns {*}
 *!/
export function getAnnotationsData(params) {
    let key = params.key;
    let clusterByAGL = params.clusterByAGL;
    let o = params.o;
    let focusAGLs = params.focusAGLs;
    let focusUIDs = params.focusUIDs;
    let setAGLs = params.setAGLs;
    let removeAGLs = params.removeAGLs;
    console.log(focusAGLs, focusUIDs, setAGLs, removeAGLs, key)
    let uuidKey = uuid();
    let emptyReplacer = 'Kein Kurztext vorhanden';

    function shortTextView(shortText) {
        if (shortText === undefined) {
            return <td>-</td>;
        } else if (shortText !== '') {
            return <td>{shortText}</td>;
        } else return <td> {emptyReplacer}</td>;
    }

    // Removes 'unique_id' key value for ease of duplicate check
    let newClusterByAGL = clusterByAGL[0][o].map((data) => {
        //delete data['unique_id'];
        return data;
    })

    // Prepares unique entries for Web Report
    let reportDataSet = new Set;
    let uniqueReportTableData = [];
    for (let newClusterByAGLEntry of newClusterByAGL) {
        //console.log(Object.values(newClusterByAGLEntry))
        let concatenatedValue = Object.values(newClusterByAGLEntry).join('');
        if (!reportDataSet.has(concatenatedValue)) {
            reportDataSet.add(concatenatedValue);
            uniqueReportTableData.push(newClusterByAGLEntry);
        }
    }

    return uniqueReportTableData.map((data) => (
        <>
            <tr key={uuidKey}>
                <td>
                    <input
                        key={uuidKey}
                        type="checkbox"
                        className="handwaiCheckbox nestingCheckbox"
                        onChange={(e) =>
                            selectSpecific({
                                event: e,
                                key: key,
                                o: o,
                                individualContent: data,
                                focusAGLs: focusAGLs,
                                focusUIDs: focusUIDs,
                                setAGLs: setAGLs,
                                removeAGLs: removeAGLs
                            })
                        }
                    />
                </td>
                <td>{data.ordnungsziffer}</td>
                {shortTextView(data.shortText)}

            <td>
                <Button className={"handwai-btn-report"}
                disabled={data.shortText==="nan"}
            onClick={()=>
            {
                let baseURL = "https://www.google.com/search?q="
                window.open(baseURL + data.googleText, 'googletext')}
            }
            ><FontAwesomeIcon icon={faSearch}/> Suchen</Button>
            </td>

                <td>{data.reason}</td>
                {/!* <td className="menge">{data.menge}</td> *!/}
                <td className="menge">{isNaN(data.menge) ? 0 : data.menge}</td>
                <td>{data.unit}</td>
            </tr>
        </>
    ));
}

/!**
 * Function provides the total number of annotations for an AGL.
 * @param clusterByAGL
 * @param o
 * @returns {number}
 *!/
export function getNumberOfAnnotations(clusterByAGL, o) {
    let counter = 0;
    clusterByAGL[0][o].map(() => (counter = counter + 1));
    return counter;
}

let isPositionCategoryPresentInAGL = (o, positionCategoryInfo) => {
    let match = false;
    Object.keys(positionCategoryInfo).forEach((key) => {
        if (o.toLowerCase().includes(key.toLowerCase())) {
            match = true;
        }
    });

    return match;
};

let getPositionCategoryDataForAGL = (positionCategoryHeader, o, positionCategoryInfo) => {
    let thePositionCategoryData = '';
    let tableData;

    let foundData = Object.keys(positionCategoryInfo).map((key) => {
        if (o.toLowerCase().includes(key.toLowerCase())) {
            positionCategoryHeader = key;
            thePositionCategoryData = positionCategoryInfo[key];
            return true;
        }
    });

    if (foundData) {
        tableData = thePositionCategoryData.map((item, index) => (
            <Table key={index} striped bordered hover variant="dark">
                <thead>
                    <tr>
                        <th>OZ</th>
                        <th>Kurztext</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{item.ref}</td>
                        <td>{item.hinweis}</td>
                    </tr>
                    <tr>
                        <td colSpan="2" style={{ 'white-space': 'pre-wrap' }}>
                            {' '}
                            {item.long_text}
                        </td>
                    </tr>
                </tbody>
            </Table>
        ));
    } else {
        tableData = <span>Kein Daten!</span>;
    }

    let positionHeader =
        <>
            <br/>
            <label className="handwai-text-label-normal" style={{fontWeight: 'bold'}}>
                {"Position(en) im LV:"}
            </label>;
        </>

    return (
        <>
            <Row>
                <Col md={1} />
                <Col className={'addMarginLeftMinus50'}>
                    {positionHeader} {tableData}
                </Col>
            </Row>
        </>
    );
};

/!**
 * Function provides the data to UI for given Annotations (content) and category (typeR).
 * @param param
 * @returns Accordion-body-data
 *!/
export async function getReportContent(param) {
    let content = param.content;
    let typeR = param.dType;
    let setAGLs = param.setAGLs;
    let removeAGLs = param.removeAGLs;
    let hinweisAGLs = param.hinweisAGLs;
    let potenzialAGLs = param.potenzialAGLs;
    let risikoAGLs = param.risikoAGLs;
    let hinweisUIDs = param.hinweisUIDs;
    let potenzialUIDs = param.potenzialUIDs;
    let risikoUIDs = param.risikoUIDs;
    let positionCategoryInfo = param.positionCategoryData;
    //let adviceCatalog = param.adviceCatalog;
    let positionCategoryDataHeader = '';

    if (content !== null && content !== "[]") {
        //Group by AGL
        let clusterByAGL = clusterBy(content, 'anspruchsgrundlage');
        clusterByAGL = [clusterByAGL];

        let keys = Object.keys(clusterByAGL[0]);
        let uuidKeys = uuid();

        let focusAGLs = [];
        let focusUIDs = [];

        if (typeR === 'Hinweis') {
            focusAGLs = hinweisAGLs;
            focusUIDs = hinweisUIDs

        } else if (typeR === 'Potenzial') {
            focusAGLs = potenzialAGLs;
            focusUIDs = potenzialUIDs
        } else if (typeR === 'Risiko') {
            focusAGLs = risikoAGLs;
            focusUIDs = risikoUIDs
        }

        keys = keys.sort((a, b) => a.localeCompare(b));

        return keys.map((o, index) => (<>
                <Card className='handwai-dark' key={uuidKeys}>
                    <Card.Header>
                        <Row>
                            <Col md={1}>
                                {focusAGLs.includes(o) ?
                                    includedInput(uuidKeys, focusAGLs, o, setAGLs, removeAGLs) :
                                    excludedInput(uuidKeys, focusAGLs, o, setAGLs, removeAGLs)}
                            </Col>
                            <Col md={10} className='addMarginLeftMinus50'>
                                <Accordion.Toggle
                                    as={Button}
                                    className='handwai-btn-create add1110Width'
                                    style={{textAlign: 'left'}}
                                    eventKey={index + 1}
                                >
                                    {parse(o)} [Anzahl: {getNumberOfAnnotations(clusterByAGL, o)}]{' '}
                                </Accordion.Toggle>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Accordion.Collapse eventKey={index + 1}>
                        <Card.Body>
                            <div
                                style={{
                                    display: 'flex',
                                    flex: 1,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    padding: '20px',
                                    color: '#fff',
                                    flexDirection: 'column'
                                }}
                            >
                                <h3>Info</h3>
                                <hr
                                    style={{
                                        border: '1px solid #fff',
                                        width: '100%'
                                    }}
                                />
                                <div
                                    style={{
                                        padding: '20px'
                                    }}
                                >
                                    {getSummaryAnnotions(clusterByAGL, typeR, o)}
                                </div>
                            </div>

                            <br />

                            <Row>
                                <Col md={1} />
                                <Col className={'addMarginLeftMinus50'}>
                                    <table
                                        className="table webReportTableSecond"
                                        style={{
                                            width: '100%'
                                        }}
                                    >
                                        <thead
                                            style={{
                                                width: '100%'
                                            }}
                                        >
                                            <tr>
                                                <th className="no-sort">Wählen</th>
                                                <th className="sort">OZ</th>
                                                <th>Kurztext</th>
                                                <th>Aktion</th>
                                                <th>Ursache</th>
                                                <th className="sort">Menge</th>
                                                <th className="sort">Einheit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {getAnnotationsData({
                                                modalData: param.modalData,
                                                key: uuidKeys,
                                                clusterByAGL: clusterByAGL,
                                                o: o,
                                                focusAGLs: focusAGLs,
                                                focusUIDs: focusUIDs,
                                                setAGLs: setAGLs,
                                                removeAGLs: removeAGLs
                                            })}
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>

                            <br />

                            {positionCategoryInfo !== null && isPositionCategoryPresentInAGL(o, positionCategoryInfo)
                                ? getPositionCategoryDataForAGL(positionCategoryDataHeader, o, positionCategoryInfo)
                                : ''}
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>

            </>

        ));
    } else {
        return <p className='handwai-text-label-normal'>{NODATACATEGORY}</p>;
    }
}

export function addSelectedAGLs(o, setAGLs) {
    setAGLs(o);

}

function removeSelectedAGLs(o, removeAGLs) {
    removeAGLs(o);
}

export function includedInput(uuid, focusAGLs, o, setAGLs, removeAGLs) {

    return <input type='checkbox'
                  key={uuid}
                  id={uuid}
                  className='handwaiCheckbox'
                  checked='true'
                  onInput={(event) => {

                      if (!focusAGLs.includes(o)) {
                          addSelectedAGLs(o, setAGLs);
                          event.target.checked = true;
                      } else {
                          removeSelectedAGLs(o, removeAGLs);
                          event.target.checked = false;
                          event.target.removeAttribute('checked');
                      }
                  }}/>;
}

export function excludedInput(uuid, focusAGLs, o, setAGLs, removeAGLs) {
    return <input type='checkbox'
                  key={uuid}
                  id={uuid}
                  className='handwaiCheckbox'
                  onInput={(event) => {

                      if (!focusAGLs.includes(o)) {
                          addSelectedAGLs(o, setAGLs);
                          event.target.checked = true;
                      } else {
                          removeSelectedAGLs(o, removeAGLs);
                          event.target.checked = false;
                      }
                  }}/>;
}

function isChecked() {
    let inputElements = [].slice.call(document.querySelectorAll('.nestingCheckbox'));
    return inputElements.filter(chk => chk.checked).length;
}

/!**
 * Select specific content from an AGL
 * @param params
 *!/
export function selectSpecific(params) {

    let e = params.event;
    let key = params.key;
    let o = params.o;
    let data = params.individualContent;
    let focusAGLs = params.focusAGLs;
    let focusUIDs = params.focusUIDs;
    let setAGLs = params.setAGLs;
    let removeAGLs = params.removeAGLs;

    if (e.target.checked === true && !focusUIDs.includes(data)) {
        // first uncheck the AGL checkbox
        document.getElementById(key).checked = false;
        addSelectedAGLs(data, setAGLs);
        // check if there is any nesting checkbox selected
        if (isChecked() >= 1) {
            if (!focusAGLs.includes(o)) {
                addSelectedAGLs(o, setAGLs)
            }
            // otherwise remove the principal AGL.
        } else {
            removeSelectedAGLs(o, removeAGLs)
        }
    } else {
        removeSelectedAGLs(data, removeAGLs)
    }

}


export function getSortedAnnotations() {
    return getAllAnnotationsDB().then(function (result) {
        // a stable sorting algorithm
        return result.sort((firstItem, secondItem) => firstItem.annotation_data.rowId - secondItem.annotation_data.rowId);
    });
}

export function save_before_publish(extractedAnnotationsData) {
    //Send clustered advice ID, with LV ID
    let lv_id = localStorage.getItem('parsedlv_id');
    // Get the current state of lv document to save the
    let positionTexts = getCurrentStateOfLvDocument();
    const analyse = {
        lv_id: lv_id
        , is_checkpoint: false
        , list_json: extractedAnnotationsData
        , lvDocument: positionTexts
    };
    // APi call for save annotations for the annotator microservice
    fetch(`${process.env.REACT_APP_BASE_URI}/api/annotator/v2/resources/annotations`, {
        method: 'POST',
        headers: {'Content-type': 'application/json; charset=UTF-8', 'Authorization': 'Bearer ' + getToken()},
        body: JSON.stringify(analyse)
    });
}

async function remove(arr, val, rowID) {
    let res = [];
    for (let item of arr) {
        if (rowID.includes(item.row_id)) {

            if (item.norm.toLowerCase() !== val) {
                res.push(item)
            }
        } else {
            res.push(item)
        }
    }
    return res;
}

/!**
 * This function publishes the lv but also has business logic for ai annotations
 *!/
const labelParams = ["<p>Planungsfabrikat</p>", "Planungsfabrikat"
    , "<p>Nicht Neutral</p>", "Nicht Neutral"
    , "<p>Unklar</p>", "Unklar", "stundenlohnarbeiten", "<p>stundenlohnarbeiten</p>", "Stundenlohnarbeiten", "<p>Stundenlohnarbeiten</p>", "beschilderung", "<p>beschilderung</p>", "Beschilderung", "<p>Beschilderung</p>"]
const stundenParam = ["ersthelfers", "Ersthelfers", "fachingenieurs", "Fachingenieurs", "FachIngenieurs", "Fachingenieur", "FachIngenieur", "fachingenieur", "Fachingenieure", "FachIngenieure", "fachingenieure", "Monteure", "Techniker", "techniker", "Montagemeister", "montagemeister", "meister", "Meister", "Ersthelfer", "ersthelfer", "Monteure", "monteure", "Systemtechniker", "systemtechniker", "Auszubildender", "elektro-ingenieur", "Elektro-Ingenieur", "elektro-ingenieure", "Elektro-Ingenieure", "elektro-ingenieurs", "Elektro-Ingenieurs", "auszubildender", "Fachingenieure", "fachingenieurs", "Fachingenieurs", "fachingenieure", "Monteure", "monteur", "monteurs", "Monteurs", "a-monteur", "A-monteur", "b-monteur", "B-Monteur", "c-monteur", "C-Monteur", "monteur/-in", "Monteur/-in", "obermonteur", +
    "Obermonteur", "Obermonteur/-in", "obermonteur/-in", "obermonteur", "Helfer/-in", "helfer/-in", "helfers", "Helfers", "Helfer", "helfer", "o-monteur", "O-monteur", "O-Monteur", "elekro-monteur", "Elekro-Monteur", "Elekro-monteur", "kernbohrmonteur", "Kernbohrmonteur", "KernbohrMonteur", "lehrling", "Lehrling", "Ausbildender", "ausbildender", "azubi", "Azubi", "ingenieur", "Ingenieur", "MSR-Ingenieur", "msr-ingenieur", "Bauhelfer", "bauhelfer", "bauhelfer/-in", "Bauhelfer/-in", "sanitärhelfer", "Sanitärhelfer", "sanitärhelfer/-in", "Sanitärhelfer/-in", "bauwerker", "Bauwerker", "facharbeiter", "Facharbeiter", "facharbeiter/-in", "Facharbeiter/-in", "geselle", "Geselle", "meister/-in", "Meister/-in", "Monteur", "techniker/-in", "Techniker/-in", "techniker", "kundendiensttechniker", "Kundendiensttechniker", "Elektrikers", "elektrikers", "elekriker", "elekriker", "elekriker/-in", "Elekriker/-in", "Systemintegrator/-in", "systemintegrator/-in", "Systemintegrator", "systemintegrator", "GA-Techniker", "ga-techniker", "objektleiter/-in", "objektleiter", "Objektleiter", "Objektleiter/-in"]

export async function publish(extractedAnnotationsData) {
    //Send clustered advice ID, with LV ID
    let lv_id = localStorage.getItem('parsedlv_id');
    let clustered = clusterBy(extractedAnnotationsData, "ord");
    let result = [];
    let ord = [];
    let tailored = [];
    for (let value of Object.values(clustered)) {
        let unique = [];
        value.map(x => unique.filter(a => a.Annotation === x.Annotation && labelParams.includes(x.norm)).length > 0 ? null : unique.push(x));
        let copyUnique = [...unique];
        copyUnique.forEach(function (item) {
            if (stundenParam.includes(item.Annotation.toLowerCase())) {
                tailored.push(item);
                ord.push(item.row_id);
            }
        });
        result.push(...unique)
    }

    let final = await remove(result, "stundenlohnarbeiten", [...new Set(ord)]);
    final.push(...tailored)
    let clusterByAdviceID = clusterBy(final, 'adviceID');

    const annotationsData = {
        'lv_id': lv_id
        , 'is_checkpoint': false
        , 'list_json': final   //this is for AI data management
        , 'cluster_adviceID': clusterByAdviceID // This is for all types of reports
    };

    // APi call for save annotations for the report microservice
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/report/v1/resources/report`, {
        method: 'POST',
        headers: {'Content-type': 'application/json; charset=UTF-8', 'Authorization': 'Bearer ' + getToken()},
        body: JSON.stringify(annotationsData)
    });
}

export async function publish_report(data) {
    data.token = getToken()
    return fetch(apilink + `annotator/publish`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}

export async function getStatistics(lvID) {

    return fetch(apilink + `annotator/get_report_stats/` + lvID, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json"
        }
    }).then((response) => response.clone().json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log('Error:', error);
        });

}

// export async function getReportDetail(lvID, detailType){
//     return fetch(apilink + `/annotator/get_report/`+lvID+"/"+detailType, {
// 		method: 'GET',
// 		headers: {
//             "Content-Type": "application/json"
//         }
// 	}).then((response) => response.clone().json())
// 		.then((data) => {
// 			return data;
// 		})
// 		.catch((error) => {
// 			console.log('Error:', error);
// 		});
// }

export async function getReportDetail(lvID) {
    return fetch(apilink + `annotator/get_report/` + lvID, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        }, body: (JSON.stringify({"token": getToken(), "met": "GET"}))
    }).then((response) => response.clone().json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log('Error:', error);
        });
}

export async function getAdditionalReportDetail(lvID) {
    return fetch(apilink + `annotator/get_add_report`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        }, body: (JSON.stringify({"token": getToken(), "lv_id": lvID}))
    }).then((response) => response.clone().json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log('Error:', error);
        });
}

// export async function getReportLink(lvID){
//     return fetch(apilink + `/annotator/get_link/`+lvID, {
// 		method: 'GET',
// 		headers: {
// 			"token":getToken(),
//             "Content-Type": "application/json"
//         }
// 	}).then((response) => response.clone().json())
// 		.then((data) => {
// 			return data;
// 		})
// 		.catch((error) => {
// 			console.log('Error:', error);
// 		});
// }

export async function getReportLink(lvID) {
    return fetch(apilink + `annotator/get_link/` + lvID, {
        method: 'POST',
        headers: {
            "token": getToken(),
            "Content-Type": "application/json"
        }, body: JSON.stringify({"token": getToken(), "met": "GET"})
    }).then((response) => response.clone().json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log('Error:', error);
        });
}


export function getRepLinkApi(report_id) {

    let tmp = `${process.env.REACT_APP_BASE_URI}` + report_id;
    return fetch(tmp,
        {
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + getToken()}
        })
        .then((response) => response.clone().json())
        .then((data) => {
            return data;
        })
        .catch((error) => {
            console.log('Error:', error);
        });
}

export async function sendClusteredAdviceID(annotationsAll) {
    let lv_id = localStorage.getItem('parsedlv_id');
    let arrayAnnot2 = [];
    for (let annotData of annotationsAll) {
        arrayAnnot2.push(annotData.annotation_data);
    }

    let clusterByAdviceID = clusterBy(arrayAnnot2, 'adviceID');

    // Prepare data for API Call
    let clusterAdviceID = {
        lv_id: lv_id, cluster_adviceID: clusterByAdviceID
    };

    // API Call to send clustered Advice ID
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/report/v1/resources/clusteradvices`, {
        method: 'POST', headers: {
            'Content-type': 'application/json; charset=UTF-8', Authorization: 'Bearer ' + getToken()
        }, body: JSON.stringify(clusterAdviceID)
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

export async function getWebReportData(lv_id) {

    // API Call
    return fetch(`${process.env.REACT_APP_BASE_URI}/api/report/v1/resources/reportdata`, {
        method: 'POST', headers: {
            'Content-type': 'application/json; charset=UTF-8', Authorization: 'Bearer ' + getToken()
        }, body: JSON.stringify({lv_id: lv_id})
    })
        .then((response) => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}*/
